import React from 'react'

export const TrendingIcon = () => (
    <svg width="25" height="20" viewBox="0 0 25 20" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient x1="5.615%" y1="77.472%" x2="100%" y2="26.124%" id="a">
                <stop stopColor="#3191FF" offset="0%" />
                <stop stopColor="#0CF" offset="100%" />
            </linearGradient>
        </defs>
        <path
            d="M25.333 4.635l-6.45-.032a.47.47 0 00-.471.468l.004 1.575.008.085a.47.47 0 00.462.383h2.94l-7.544 8.101-3.878-3.125a1.119 1.119 0 00-1.631-.009l-7.584 7.73a1 1 0 00-.002 1.4l.288.295a1 1 0 001.431 0L9.652 14.6l3.782 3.042.093.1c.442.442.964.541 1.498.145l8.43-8.998v3.103c0 .25.197.456.446.468l1.407.069a.47.47 0 00.491-.446V5.104a.47.47 0 00-.466-.469z"
            fill="url(#a)"
            fillRule="nonzero"
            transform="rotate(-5 -21.505 23.157)"
        />
    </svg>
)

export const ArtistsIcon = () => (
    <svg width="21" height="26" viewBox="0 0 21 26" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient x1="15.313%" y1="100%" x2="84.687%" y2="0%" id="b">
                <stop stopColor="#E646B6" offset="0%"></stop>
                <stop stopColor="#FF6666" offset="100%"></stop>
            </linearGradient>
        </defs>
        <path
            d="M3.9 23.67c-.636-.46-.798-1.112-.485-1.958l2.36-7.256H1.308a1.34 1.34 0 01-1.126-.614c-.244-.379-.244-.998 0-1.377L7.334.613C7.547.233 7.974 0 8.46 0h10.226c.457 0 .883.234 1.126.613.244.38.213.876-.03 1.255l-4.991 7.649h3.201c.548 0 1.004.32 1.217.788.183.467.061.992-.304 1.343L6.25 23.493c-.274.263-1.396.866-2.35.177zm-.88-11.117h3.886c.426 0 1.007-.053 1.285.525.222.324.222.74 0 1.25l-2.094 6.026a.2.2 0 00.33.207l8.8-8.797a.2.2 0 00-.142-.341h-1.61 0c-.457 0-.963.13-1.405-.468-.442-.598-.243-1.174 0-1.554l5.115-7.419a.2.2 0 00-.164-.313l-7.67-.001a.3.3 0 00-.258.146L2.85 12.25a.2.2 0 00.172.303z"
            transform="translate(1 1)"
            fill="url(#b)"
            fillRule="nonzero"
            stroke="url(#b)"
            strokeWidth=".1"
        />
    </svg>
)

export const VideosIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="c">
                <stop stopColor="#00E6CC" offset="0%" />
                <stop stopColor="#0F9" offset="100%" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                d="M21.742.969a2.4 2.4 0 012.4 2.4v19.2a2.4 2.4 0 01-2.4 2.4h-19.2a2.4 2.4 0 01-2.4-2.4v-19.2a2.4 2.4 0 012.4-2.4zm-.192 2.2H2.734a.392.392 0 00-.392.392v18.816c0 .216.175.392.392.392H21.55a.392.392 0 00.392-.392V3.56a.392.392 0 00-.392-.392zM9.314 7.679c.204 0 .397.055.619.182l6.783 4.452c.24.184.393.462.393.782s-.152.598-.462.83c-8.497 5.24-7.102 4.39-7.325 4.345l-.163-.01a1.071 1.071 0 01-.528-.213l-.33-.253.01-9.72.427-.242c.176-.1.372-.153.576-.153zm.833 2.39l-.005 5.962 4.7-2.882-4.695-3.08z"
                fill="url(#c)"
                fillRule="nonzero"
                transform="translate(-.142 -.969)"
            />
        </g>
    </svg>
)

export const StoriesIcon = () => (
    <svg width="22" height="25" viewBox="0 0 22 25" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient x1="7.986%" y1="100%" x2="92.014%" y2="0%" id="d">
                <stop stopColor="#6157FF" offset="0%" />
                <stop stopColor="#93F" offset="100%" />
            </linearGradient>
        </defs>
        <path
            d="M20.25 25a.75.75 0 110 1.5H7.75a.75.75 0 110-1.5h12.5zm2-3a.75.75 0 110 1.5H5.75a.75.75 0 110-1.5h16.5zm-.134-19.5C23.709 2.5 25 3.719 25 5.222v12.556c0 1.503-1.291 2.722-2.884 2.722H5.884C4.291 20.5 3 19.281 3 17.778V5.222C3 3.719 4.291 2.5 5.884 2.5zm-.215 2.2H6.099c-.496 0-.899.371-.899.83v11.94c0 .459.403.83.9.83h15.8c.497 0 .9-.371.9-.83V5.53c0-.459-.403-.83-.9-.83z"
            transform="translate(-3 -2)"
            fill="url(#d)"
            fillRule="nonzero"
        />
    </svg>
)
